import { createStore } from 'vuex'

export default createStore({
  state: {
    //ROBA MIA
    UserInfo: {
      token: "",
    },
    dataLogin: null,
    MessaggioGlobale: {
        mostraMessaggio: "",
        alertMessaggio: [""],
        alertClass: "",     
        alertIcon: "",
        alertIconSpin: false,
    },
    ValoriDefault: {
      //inserire i valori di default
    }
  },
  getters: {
  },
  mutations: {
    //ROBA MIA
    UserInfo (state, o) {
      state.UserInfo = o
    },
    dataLogin (state, val) {
      state.dataLogin = val
    },
    token (state, t) {
        state.UserInfo.token = t
    },
    Messaggio (state, o) {
        state.MessaggioGlobale.mostraMessaggio= o.parms[0];
        state.MessaggioGlobale.alertMessaggio = o.parms[1];
        state.MessaggioGlobale.alertClass= o.parms[2];     
        state.MessaggioGlobale.alertIcon =  o.parms[3];
        state.MessaggioGlobale.alertIconSpin = o.parms[4];
        if(o.parms[5]>0) {
            window.setTimeout(() => {
                state.MessaggioGlobale.mostraMessaggio= false;
            }, o.parms[5] )
        }
    },
    
    // ValoriDefault(state, o) {
    
    // }
  },
  actions: {
  },
  modules: {
  }
})
